import React from 'react'
import { useSelector } from 'react-redux'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import Scroller from 'components/Scroller'
import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import DemoInboxCard from 'components/TrialSetup/DemoInboxCard'
import TicketList from 'subapps/ticketing/components/TicketList'
import { selectShowDemoInboxCard } from 'selectors/trial_setup'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import {
  selectCurrentMailboxHasTickets,
  selectCurrentMailboxId,
  selectDoesCurrentMailboxHaveState,
  selectIsSettingUpTheCurrentMailBox,
} from 'selectors/mailboxes'
import { selectShowContinueForwardingSetupPane } from 'selectors/layout'
import { selectSearchesRequestState } from 'selectors/search'

import ActionBar from './ActionBar'
import SearchBar from './SearchBar'
import { styles } from './styles'
import MailboxContinueForwardingSetupBar from '../../../MailboxContinueForwardingSetupBar'

// Wraps the ticket list container and adds mouseEnter/Leave events
export default function TicketListPane({
  hasSearchErrored,
  isQueryStringValid,
  queryString,
}) {
  const showDemoInboxCard = useSelector(selectShowDemoInboxCard)
  const showTopNav = useSelector(selectPrefersShowTopNav)
  const currentMailboxId = useSelector(selectCurrentMailboxId)
  const currentMailboxHasTickets = useSelector(selectCurrentMailboxHasTickets)
  const isCurrentMailboxConfirmedOrUnconfirmed = useSelector(state =>
    selectDoesCurrentMailboxHaveState(state, ['unconfirmed'], null, [
      'FORWARDING',
    ])
  )
  const isSettingUpTheCurrentMailBox = useSelector(
    selectIsSettingUpTheCurrentMailBox
  )
  const showContinueForwardingSetupPane = useSelector(
    selectShowContinueForwardingSetupPane
  )
  const { loaded, error } = useSelector(selectSearchesRequestState)
  const isSearchesLoaded = loaded && !error

  const showMailboxContinueForwardingSetupBar =
    isCurrentMailboxConfirmedOrUnconfirmed &&
    !isSettingUpTheCurrentMailBox &&
    !showContinueForwardingSetupPane &&
    isSearchesLoaded

  return (
    <div css={[styles.base]}>
      {!showTopNav && <SearchBar />}

      {(currentMailboxHasTickets === true || !currentMailboxId) && (
        <ActionBar />
      )}

      {queryString && hasSearchErrored && <SearchErrorMessage />}

      {queryString &&
        !isQueryStringValid &&
        !hasSearchErrored && (
          <Scroller className="desktopNormalScrollbarDisableRightBorder">
            <InvalidSearchMessage queryString={queryString} />
          </Scroller>
        )}
      {showMailboxContinueForwardingSetupBar && (
        <MailboxContinueForwardingSetupBar />
      )}
      {(!queryString || (!hasSearchErrored && isQueryStringValid)) && (
        <TicketList is3ColumnView isSidebarOpen />
      )}
      {showDemoInboxCard && <DemoInboxCard />}
    </div>
  )
}
